import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { operations as docServiceOperations } from 'store/docServiceManager'
import { operations as lmsOperations } from 'store/lmsManager'
import AdminExportDownloadButton from './component'

const AdminExportDownloadButtonContainer = ({
  className,
  clearDocumentUrl,
  documentUrl,
  fetchDocumentUrl,
  fetchHsLeaderHistoricalReports,
  fetchK8LeaderHistoricalReports,
  isFetchingCurrentYear,
  programKey,
  selectedProgram,
  tooltipLocation,
  user,
  usersHistoricalUserReports,
  buttonText,
}) => {
  const [
    isDownloadingHistoricalUserReports,
    setDownloadingHistoricalUserReports,
  ] = useState(false)
  useEffect(() => {
    if (documentUrl) {
      // download current year document
      const downloadLink = document.createElement('a')
      downloadLink.href = documentUrl
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
      clearDocumentUrl()
    }
  }, [documentUrl, clearDocumentUrl])

  const handleClickCurrentYear = useCallback(() => {
    if (!isFetchingCurrentYear && !documentUrl) {
      fetchDocumentUrl({ userEmail: user?.email, program: selectedProgram })
    }
    return true
  }, [documentUrl, isFetchingCurrentYear, selectedProgram, user?.email])

  useEffect(() => {
    if (user?.id && programKey) {
      if (programKey.includes('K8')) {
        fetchK8LeaderHistoricalReports(user.id)
      }
      if (programKey.includes('HS')) {
        fetchHsLeaderHistoricalReports(user.id)
      }
    }
  }, [
    user?.id,
    programKey,
    fetchK8LeaderHistoricalReports,
    fetchHsLeaderHistoricalReports,
  ])

  const historicalReportingOnClick = async (data, filename, url) => {
    if (!url && !data) {
      return false
    }

    if (!data) {
      try {
        // fetch from the url so we can change the name of the file
        setDownloadingHistoricalUserReports(true)
        const response = await fetch(url)
        const blob = await response.blob()
        const newUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = newUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // done
        window.URL.revokeObjectURL(newUrl)
        setDownloadingHistoricalUserReports(false)

        return true
      } catch (error) {
        console.error('Error downloading file:', error)
        return false
      }
    }

    return { data, filename }
  }
  return (
    <AdminExportDownloadButton
      buttonText={buttonText}
      className={className}
      historicalReportingOnClick={historicalReportingOnClick}
      historicalReports={usersHistoricalUserReports}
      isFetching={isFetchingCurrentYear || isDownloadingHistoricalUserReports}
      onClickCurrentYear={handleClickCurrentYear}
      programKey={programKey}
      tooltipLocation={tooltipLocation}
    />
  )
}

const mapStateToProps = ({
  docServiceManager,
  userProfileManager,
  reportsManager,
  lmsManager,
}) => {
  const { key: selectedProgramKey } = reportsManager.selectedProgram || {}
  const { historicalUserReports } = lmsManager

  return {
    documentUrl: docServiceManager.documentUrl,
    isFetchingCurrentYear: docServiceManager.isFetching,
    user: userProfileManager?.profile,
    selectedProgram: selectedProgramKey,
    usersHistoricalUserReports:
      historicalUserReports?.[selectedProgramKey] || [],
  }
}

const mapDispatchToProps = {
  clearDocumentUrl: docServiceOperations.clearDocumentUrl,
  fetchDocumentUrl: docServiceOperations.fetchDocumentUrl,
  fetchK8LeaderHistoricalReports: lmsOperations.fetchK8LeaderHistoricalReports,
  fetchHsLeaderHistoricalReports: lmsOperations.fetchHsLeaderHistoricalReports,
}

AdminExportDownloadButtonContainer.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  clearDocumentUrl: PropTypes.func,
  documentUrl: PropTypes.string,
  fetchDocumentUrl: PropTypes.func,
  fetchHsLeaderHistoricalReports: PropTypes.func,
  fetchK8LeaderHistoricalReports: PropTypes.func,
  isFetchingCurrentYear: PropTypes.bool,
  isFetchingHistoricalUserReports: PropTypes.bool,
  programKey: PropTypes.string,
  selectedProgram: PropTypes.string,
  tooltipLocation: PropTypes.string,
  user: PropTypes.object,
  usersHistoricalUserReports: PropTypes.array,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminExportDownloadButtonContainer)
